export default "__VITE_ASSET__CmxAqYzA__"